import { IsLatitude, IsLongitude, IsOptional } from "class-validator";

export class BookingEndRequest {
  @IsOptional()
  @IsLatitude()
  latitude?: number;

  @IsOptional()
  @IsLongitude()
  longitude?: number;
}
